module.exports = __webpack_public_path__ + "media/images/grey_filter-52c03031632932a4540f7cc246d2978d.svg";